const generateColorIndex = async (
    file: File,
    { updateProcessingProgress }: { updateProcessingProgress: (progress: number) => void }
) => {
    const worker = new Worker(new URL("./colorIndex.worker.ts", import.meta.url))

    return await new Promise<{
        superIndex: Uint32Array[]
        anomalyScores: Uint8Array
    }>((resolve, reject) => {
        worker.addEventListener("message", (message) => {
            if (message.data?.progress) return updateProcessingProgress(message.data.progress)
            if (!message.data) reject("Could not parse video")
            updateProcessingProgress(1)
            resolve(message.data)
            worker.terminate()
        })
        const canvas = document.createElement("canvas").transferControlToOffscreen()
        worker.postMessage({ file, canvas }, [canvas])
    })
}

export { generateColorIndex }
